module.exports = __webpack_public_path__ + "static/media/lenovo_265.3c4a5b53.png";